<template>
  <of-dialog :title="formTitle" @onCancel="cancel" :width="width">
    <div slot="content">
      <el-form ref="form" label-width="140px" :model="dataForm">
        <el-form-item label="申请人：">
          <p>{{dataForm.UserName}}</p>
        </el-form-item>
        <el-form-item label="票据项目：">
          <p>{{dataForm.BusinessTitle}}</p>
        </el-form-item>
        <el-form-item label="票据类型：">
          <p>{{isElectronicInvoice}}</p>
        </el-form-item>
        <el-form-item label="票据抬头：">
          <p>{{dataForm.UnitName}}</p>
        </el-form-item>
        <el-form-item label="纳税人识别号：" v-show="invoiceType">
          <p>{{dataForm.TaxpayerNum}}</p>
        </el-form-item>
        <el-form-item label="收件人：">
          <p>{{dataForm.UnitName}}</p>
        </el-form-item>
        <el-form-item label="地址：">
          <p>{{dataForm.Address}}</p>
        </el-form-item>
        <el-form-item label="电话号码：">
          <p>{{dataForm.Contact}}</p>
        </el-form-item>
        <el-form-item label="票据状态：" v-if="dataForm.IsElectronicInvoice">
          <p>{{status}}</p>
        </el-form-item>
        <el-form-item label="票据领取方式：" v-else>
          <p>{{receiveType}}</p>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null
    },
    formTitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      width: "40%"
    };
  },
  mounted() {
  },
  components: {
    OfDialog
  },
  computed: {
    //是否电子发票
    isElectronicInvoice() {
      return this.dataForm.IsElectronicInvoice ? "电子票据" : "纸质票据";
    },
    //开票状态
    status() {
      return this.dataForm.Status == 0 ? "未开票" : "已开票";
    },
    //发票领取方式
    receiveType() {
      return this.dataForm.ReceiveType == 0 ? "快递邮寄" : "上门自取";
    },
    //判断团体&&个人开票
    invoiceType() {
      return this.dataForm.InvoiceType == 0 ? false : true;
    }
  },
  methods: {
    cancel() {
      this.$emit("formCallBack", null);
    }
  }
};
</script>


<style scoped>
.el-textarea > textarea {
  height: 80px;
}

.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}

.el-dialog__wrapper >>> .el-dialog .el-dialog__footer .el-button--primary {
  display: none;
}

.el-dialog__wrapper >>> .el-dialog .el-dialog__footer .el-button--default {
  display: none;
}

.el-form >>> .el-form-item {
  margin-bottom: 0;
}

/* .el-form >>> .el-form-item__label {
  margin-left: 15%;
} */
</style>
